import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { TreeNode } from 'primeng/api';
import { PickList } from 'primeng/picklist';
import { DocumentTemplateManagementConstants } from '../document-template-management-constants';
import { DocumentTemplateAssignment } from '../models/document-template-assignment';
import { DocumentTemplateItem } from '../models/document-template-item';
import { ScopeDocumentTemplates } from '../models/scope-document-templates';
import { DocumentTemplateManagementInteractionService } from '../services/document-template-management-interaction.service';
import { DocumentTemplateManagementService } from '../services/document-template-management.service';

@Component({
  selector: 'app-eqms-scope-configuration',
  templateUrl: './eqms-scope-configuration.component.html',
  styleUrls: ['./eqms-scope-configuration.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class EqmsScopeConfigurationComponent implements OnInit {
  @ViewChild('pickList') pickList!: PickList;
  isEqmsScopeSelected: boolean = false;
  selectedNode: any;
  documentTemplateAssignment!: DocumentTemplateAssignment;
  treeData: TreeNode[] = [];
  availableList: DocumentTemplateItem[] = [];
  inUseList: DocumentTemplateItem[] = [];
  parentScopeIds: string[] = [];
  scopeDocumentTemplates!: ScopeDocumentTemplates;
  pickListFilterField: string = DocumentTemplateManagementConstants.Document_Template_Management_Scope_PickList_Filter;
  sourceHeaderTitle: string = DocumentTemplateManagementConstants.Document_Template_Management_Scope_Source_Header;
  targetHeaderTitle: string = DocumentTemplateManagementConstants.Document_Template_Management_Scope_Target_Header;
  filterPlaceHolderText: string = DocumentTemplateManagementConstants.Document_Template_Management_Scope_PickList_Filter_PlaceHolder;
  treeSelectPlaceHolderText: string = DocumentTemplateManagementConstants.Document_Template_Management_Scope_Tree_Select_PlaceHolder;
  loadDocumentTemplatesForScopeConfigurationInProgress: boolean = false;
  documentTemplatesForScopeConfigurationProgressMessage: string = '';
  commonDocumentTemplateIds: string[] = [];
  constructor(
    private documentTemplateManagementService: DocumentTemplateManagementService,
    private documentTemplateManagementInteractionService: DocumentTemplateManagementInteractionService
  ) { }

  ngOnInit(): void {
    this.loadEQMSScope();
    this.documentTemplateManagementInteractionService.removeScopeSelection$.subscribe((removeScopeSelection) => {
      if (removeScopeSelection) {
        this.selectedNode = null;
        this.isEqmsScopeSelected = false;
      };
    })
  }
  loadEQMSScope = () => {
    this.documentTemplateManagementService.getEQMSScopeForConfiguration().subscribe((eQMSScope) => {
      this.treeData.push(this.createTreeNode(eQMSScope));
    });
  }

  private createTreeNode(node: any): TreeNode {
    const isNodeEnabled = node.isEnable; 
    return {
      label: node.eQMSScopeName,
      data: node,
      expanded: true,
      selectable: isNodeEnabled,
      children: node.children ? this.createChildNodes(node.children) : undefined,
      style: isNodeEnabled ? 'color: #000000' : 'color: #888'
    };
  }
  
  private createChildNodes(nodes: any[]): TreeNode[] {
    return nodes.map(childNode => this.createTreeNode(childNode));
  }

  nodeSelect = (selectedScope: any) => {
    this.parentScopeIds = [];
    this.documentTemplatesForScopeConfigurationProgressMessage =
      DocumentTemplateManagementConstants.Document_Template_For_Scope_Configuration_Loading_Progress_Message;
    this.loadDocumentTemplatesForScopeConfigurationInProgress = true;
    this.isEqmsScopeSelected = true;
    if (!!selectedScope.node.parent) {
      this.calculateParentScopeIds(selectedScope.node.parent);
    }
    this.documentTemplateAssignment = {
      primaryeQMSScopeId: selectedScope.node.data.eQMSScopeId,
      parentScopeIDs: this.parentScopeIds
    }
    this.documentTemplateManagementService.loadDocumentTemplatesForScope(this.documentTemplateAssignment)
      .subscribe((documentTemplates) => {
        this.inUseList = documentTemplates.documentTemplatesList;
        this.availableList = documentTemplates.availableDocumentTemplates;
        this.commonDocumentTemplateIds = documentTemplates.commonWithInheritedDocumentTemplateIds
        if (!!this.pickList) this.pickList.resetFilter();
        this.disableParentDocumentTemplates(100);
      });

  }
  nodeUnselect = (unselectedScope: any) => {
    this.isEqmsScopeSelected = false;
  }
  //PickList Operations 
  onMoveToTarget = (documentTemplates: any) => {
    this.prepareUpdateDocumentTemplateForScope(documentTemplates.items, true, false);
  }
  onMoveToSource = (documentTemplates: any) => {
    this.prepareUpdateDocumentTemplateForScope(documentTemplates.items, false, false);
  }
  onMoveAllToTarget = (documentTemplates: any) => {
    this.prepareUpdateDocumentTemplateForScope(documentTemplates.items, true, false);
  }
  onMoveAllToSource = (documentTemplates: any) => {
    documentTemplates.items = documentTemplates.items.filter((template: any) => {
      return !template.isParentScopeOfDocumentTemplate;
    })
    this.prepareUpdateDocumentTemplateForScope(documentTemplates.items, false, true);
  }
  onTargetFilter = () => {
    this.disableParentDocumentTemplates(10);
  }
  // End of Pick list Operations

  private prepareUpdateDocumentTemplateForScope = (documentTemplateItems: DocumentTemplateItem[],
    istemplatesAdded: boolean, isHardRefresh: boolean) => {
    this.documentTemplatesForScopeConfigurationProgressMessage =
      DocumentTemplateManagementConstants.Document_Template_For_Scope_Configuration_Save_Progress_Message;
    this.loadDocumentTemplatesForScopeConfigurationInProgress = true;
    let templateIds: string[] = [];
    documentTemplateItems.forEach((template) => {
      templateIds.push(template.documentTemplateId);
    });
    this.scopeDocumentTemplates = {
      eQMSScopeID: this.documentTemplateAssignment.primaryeQMSScopeId,
      inUseDocumentTemplateIds: istemplatesAdded ? templateIds : [],
      removedDocumentTemplateIds: istemplatesAdded ? [] : templateIds
    }
    this.documentTemplateManagementService
      .updateDocumentTemplatesForScope(this.scopeDocumentTemplates).subscribe(() => {
        if (!istemplatesAdded) {
          this.checkCommonTemplateIds(templateIds, isHardRefresh)
        } else {
          this.loadDocumentTemplatesForScopeConfigurationInProgress = false;
        }
      })
  }

  private calculateParentScopeIds = (dataNode: any): void => {
    this.parentScopeIds = [];
    while (!!dataNode.parent) {
      this.parentScopeIds.push(dataNode.data.eQMSScopeId);
      dataNode = dataNode.parent;
    };
    this.parentScopeIds.push(dataNode.data.eQMSScopeId);
  }
  private checkCommonTemplateIds = (templateIds: string[], isHardRefresh: boolean) => {
    let isRefreshDocumentTemplatesPickList = false;
    if (!isHardRefresh) {
      templateIds.forEach((templateId) => {
        if (this.commonDocumentTemplateIds.indexOf(templateId) > -1) {
          isRefreshDocumentTemplatesPickList = true;
          return;
        }
      });
    }
    if (isRefreshDocumentTemplatesPickList || isHardRefresh) {
      setTimeout(() => {
        this.documentTemplateManagementService.loadDocumentTemplatesForScope(this.documentTemplateAssignment)
          .subscribe((documentTemplates) => {
            this.inUseList = documentTemplates.documentTemplatesList;
            this.availableList = documentTemplates.availableDocumentTemplates;
            this.commonDocumentTemplateIds = documentTemplates.commonWithInheritedDocumentTemplateIds
            this.disableParentDocumentTemplates(100);
          });
      }, 1000);
    } else {
      this.loadDocumentTemplatesForScopeConfigurationInProgress = false;
    }
  }
  private disableParentDocumentTemplates = (timeToWait: number) => {
    setTimeout(() => {
      let parentDocumentTemplateDivList = document.querySelectorAll('div.p-picklist-target-wrapper ul li .parent-document-template');
      parentDocumentTemplateDivList.forEach((ele) => {
        ele.parentElement?.classList.add('inherited-template');
      })
      this.loadDocumentTemplatesForScopeConfigurationInProgress = false;
    }, timeToWait);
  }
}
